// Remembers the Library sort order across reloads. Plain string in localStorage,
// mirroring train/selected-set.ts (SSR-safe + quota/private-mode tolerant).
const STORAGE_KEY = "library.sortOrder";

export type LibrarySort = "date" | "name";

export function loadLibrarySort(): LibrarySort {
  if (typeof localStorage === "undefined") return "date";
  try {
    return localStorage.getItem(STORAGE_KEY) === "name" ? "name" : "date";
  } catch {
    return "date";
  }
}

export function saveLibrarySort(sort: LibrarySort): void {
  try {
    localStorage.setItem(STORAGE_KEY, sort);
  } catch {
    /* private mode / quota — ignore, in-memory state still applies */
  }
}
